// import {Injectable} from '@angular/core';
// import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
// import {AuthService} from "../services/auth.service";
// import {Observable, of} from "rxjs";
// import {catchError, filter, map, take, timeout} from 'rxjs/operators';
// import { DataService } from '../pages/services/data.service';
// import { Globals } from '../pages/services/globals';

// declare var setSmartechEnable;

// @Injectable()
// export class RoleGuardService implements CanActivate {
//   smartechEnabled = setSmartechEnable;

//   constructor(private _authService: AuthService,private dataservice : DataService, private globals: Globals,
//               private  _router: Router) {

//   }

//   canActivate(next: ActivatedRouteSnapshot, step: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
//     if (this.smartechEnabled) {
//       return true;
//     }

//     const requiredRole = next.data?.['role'] as string | undefined;
//     if (!requiredRole) {
//       return true;
//     }

//     if (this.globals?.product_type === 'conv_apps') {
//       return true;
//     }

//     const user = sessionStorage.getItem('loginUserAccountType');
//     if (user) {
//       if (user === requiredRole) {
//         return true;
//       }
//       this._router.navigate(['/dashboard']);
//       return false;
//     }

//     // Deep link: menu CHECK_SUBUSER has not written sessionStorage yet; wait for same source of truth.
//     return this._authService.isMaster$.pipe(
//       filter((r): r is 'master' | 'subaccount' => r === 'master' || r === 'subaccount'),
//       take(1),
//       timeout(15000),
//       map((resolved) => {
//         if (resolved === requiredRole || this.globals?.product_type === 'conv_apps') {
//           return true;
//         }
//         this._router.navigate(['/dashboard']);
//         return false;
//       }),
//       catchError(() => {
//         this._router.navigate(['/dashboard']);
//         return of(false);
//       })
//     );
//   }

// }

import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from "@angular/router";
import {AuthService} from "../services/auth.service";
import {Observable, of} from "rxjs";
import { DataService } from '../pages/services/data.service';
import { Globals } from '../pages/services/globals';
import { map, filter, take, timeout, catchError } from 'rxjs/operators';

declare var setSmartechEnable;

@Injectable()
export class RoleGuardService implements CanActivate {
  smartechEnabled = setSmartechEnable;

  constructor(private _authService: AuthService,private dataservice : DataService, private globals: Globals,
              private  _router: Router) {

  }

  canActivate(next: ActivatedRouteSnapshot, step: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const requiredRole = next.data?.['role'] as string | undefined;

    // Smartech iframe: WA-token gate only for routes without an explicit role (legacy WA-only paths).
    // Routes with data.role (e.g. /billings/details) must use master/subaccount checks like normal app.
    if (this.smartechEnabled && !requiredRole) {
      return this.dataservice.isWaTokenGenerated$.pipe(
        map(bool => bool === true)
      );
    }
    if (!requiredRole) {
      return true;
    }

    if (this.globals?.product_type === 'conv_apps') {
      return true;
    }

    const user = sessionStorage.getItem('loginUserAccountType');

    if (user) {
      if (user === requiredRole) {
        return true;
      }
      this._router.navigate(['/dashboard']);
      return false;
    }

    // Deep link: CHECK_SUBUSER / menu has not written sessionStorage yet; same source as AuthService.isMaster$.
    return this._authService.isMaster$.pipe(
      filter((r): r is 'master' | 'subaccount' => r === 'master' || r === 'subaccount'),
      take(1),
      timeout(15000),
      map((resolved) => {
        if (resolved === requiredRole || this.globals?.product_type === 'conv_apps') {
          return true;
        }
        this._router.navigate(['/dashboard']);
        return false;
      }),
      catchError(() => {
        this._router.navigate(['/dashboard']);
        return of(false);
      })
    );
  }

}
